import { useReactFlow } from "reactflow";
import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";

const useAutoPanOnDrag = () => {
  const { setViewport, getViewport } = useReactFlow();
  const rafRef = useRef(null);
  const { dragInProgress } = useSelector((state) => state.designer.flows);

  useEffect(() => {
    if (!dragInProgress) {
      cancelAnimationFrame(rafRef.current);
      return;
    }

    const flowPane = document.querySelector(".react-flow__pane");
    if (!flowPane) return;

    const handleMove = (e) => {
      const rect = flowPane.getBoundingClientRect();
      const edgeThreshold = 30;
      const panSpeed = 10;

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      let dx = 0;
      let dy = 0;

      if (x < edgeThreshold) dx = panSpeed;
      else if (x > rect.width - edgeThreshold) dx = -panSpeed;

      if (y < edgeThreshold) dy = panSpeed;
      else if (y > rect.height - edgeThreshold) dy = -panSpeed;

      if (dx || dy) {
        if (!rafRef.current) {
          const animate = () => {
            const viewport = getViewport();
            setViewport({
              x: viewport.x + dx,
              y: viewport.y + dy,
              zoom: viewport.zoom
            });
            rafRef.current = requestAnimationFrame(animate);
          };
          rafRef.current = requestAnimationFrame(animate);
        }
      } else {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };

    flowPane.addEventListener("dragover", handleMove);

    return () => {
      flowPane.removeEventListener("dragover", handleMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, [dragInProgress, setViewport, getViewport]);
};

export default useAutoPanOnDrag;
